import { FaturamentoProdutoCreditoFinanceiro }
  from './faturamento-produto-credito-financeiro.model';

export class FaturamentoCreditoFinanceiro {

  id: number;
  faturamentoProdutoCreditoFinanceiro: FaturamentoProdutoCreditoFinanceiro;
  faturamentoBruto: number;
  exportacoes: number;
  vendasZfm: number;
  quantidadeProduzida: number;
  suspensaoIpi: number;
  recolhimentoIpi: number;
  recolhimentoIcms: number;
  recolhimentoDevolucoes: number;
  recolhimentoIcmsSt: number;
  incentivoIcms: number;
  cumpriuPpb: boolean;
  pdim: number;
  pdic: number;
  credito: number;
}
